<nav>
  <div class="nav_top_container">
    <!-- <div class="logo_container">
            <div class="logo_container_left">
                <img src=".../../assets/images/VitalHub.svg" />
            </div>
            <div class="logo_container_right">
                <img src=".../../assets/images/nha.svg" />
                <img src=".../../assets/images/abha.svg" />
            </div>
        </div> -->
    <div>
      <img class="logo_image" src="../../assets/images/login1.png" />
      <!-- <img class="logo_image" src="../../assets/images/login2.png" /> -->
      <img class="logo_image" src="../../assets/images/login3.png" />
      <!-- <img src="../../assets/images/HCX.svg" class="nav_hcx_logo" />
            <span class="nav_title">National Health Claim Exchange</span> -->
      <!-- <img class="logo" src="../../assets/images/login2.png" />
            <img class="logo" src="../../assets/images/login3.png" /> -->
    </div>
    <!-- <div>
            <img src=".../../assets/images/logo.svg" class="nav_logo" />
            <img src="../../assets/images/HCX.svg" class="nav_hcx_logo" />
            <span class="nav_title">Health Claim Exchange</span>
        </div> -->
    <div class="bell_container">
      <!-- <div class="menu_main" (mouseenter)="toggleNotoficationActive(true)"
                (mouseleave)="toggleNotoficationActive(false)">
                <div class="bell">
                    <b>{{totalNotifications}}</b>
                    <img src="../../assets/images/bell.svg" class="bell_icon shake" />
                </div>
                <div class="menu notification" [class.active]="notificationActive">
                    <div class="notification_head">
                        <div class="notification_title">Notifications ({{totalNotifications}})</div>
                        <button class="see_all_btn" (click)="clearAllNotification()"
                            *ngIf="notifications.length > 0">Clear All</button>
                    </div>
                    <div class="notification_list_container">
                        <div class="notification_container" *ngFor="let not of notifications"
                            (click)="notificationClick(not)">
                            <div>{{not.message}}</div>
                            <div class="time">{{timeAgo(not.createdAt)}}</div>
                        </div>

                        <p *ngIf="notifications.length == 0" style="text-align: center; font-size: 15px;">No
                            notifications</p>
                    </div>


                    <div class="notification_bottom" *ngIf="notifications.length > 0">
                        <button class="see_all_btn" (click)="showAllNotification()" *ngIf="!allNotification">Show all
                            notifications</button>
                        <button class="see_all_btn" (click)="showFewerNotification()" *ngIf="allNotification">Show fewer
                            notifications</button>
                    </div>
                </div>
            </div> -->

      <div
        class="menu_main"
        (mouseenter)="toggleActive(true)"
        (mouseleave)="toggleActive(false)"
      >
        <img src="../../assets/images/person_pin.svg" />

        <div class="menu" [class.active]="isActive">
          <ul>
            <!-- <li data-bs-toggle="modal" data-bs-target="#staticBackdrop"><a><i
                                    class="fa-solid fa-arrow-right-from-bracket"></i>&nbsp;Log out</a></li> -->
            <li (click)="logout()">
              <a
                ><i class="fa-solid fa-arrow-right-from-bracket"></i>&nbsp;Log
                out</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div
      (click)="toggleMobileMenu()"
      [ngClass]="{ ham: true, active: mobileMenu }"
    >
      <span></span>
      <span></span>
      <span></span>
    </div>

    <div [ngClass]="{ mobile_menu: true, active: mobileMenu }">
      <ul>
        <li [class.active]="currentRoute == '/dashboard'">
          <img src="../../assets/images/dashBoard_icon.svg" />
          <a routerLink="/dashboard">Dashboard</a>
        </li>
        <li [class.active]="currentRoute.split('/')[1] == 'claim-tracker'">
          <img src="../../assets/images/claimIcon.svg" />
          <a routerLink="/claim-tracker">Claim Tracker Hub</a>
        </li>
        <li [class.active]="currentRoute == '/patient/list'">
          <img src="../../assets/images/Members.svg" />
          <a routerLink="/patient/list">Registered Members</a>
        </li>
        <li [class.active]="currentRoute == '/hospitals'">
          <img src="../../assets/images/hospital.svg" />
          <a routerLink="/hospitals">Hospitals</a>
        </li>
        <!-- <li [class.active]="currentRoute == '/insurance-lookup'">
                    <img src="../../assets/images/lookupIcon.svg" />
                    <a routerLink="/insurance-lookup">Insurance Lookup</a>
                </li> -->

        <li [class.active]="currentRoute == '/setup-doctors'">
          <img src="../../assets/images/setupDoctorIcon.svg" />
          <a routerLink="/setup-doctors">Doctors</a>
        </li>

        <li [class.active]="currentRoute == '/payer-details'">
          <img src="../../assets/images/lookupIcon.svg" />
          <a routerLink="/payer-details">Payer Details</a>
        </li>

        <!-- <li>
                    <img src="../../assets/images/settingsIcon.svg" />
                    <a>Settings</a>
                </li> -->
      </ul>
    </div>
  </div>

  <div class="nav_bottom_container">
    <ul>
      <li [class.active]="currentRoute == '/dashboard'">
        <img src="../../assets/images/dashBoard_icon.svg" />
        <a routerLink="/dashboard">Dashboard</a>
      </li>
      <li [class.active]="currentRoute.split('/')[1] == 'claim-tracker'">
        <img src="../../assets/images/claimIcon.svg" />
        <a routerLink="/claim-tracker">Claim Tracker Hub</a>
      </li>
      <li [class.active]="currentRoute == '/patient/list'">
        <img src="../../assets/images/Members.svg" />
        <a routerLink="/patient/list">Registered Members</a>
      </li>
      <li [class.active]="currentRoute == '/hospitals'">
        <img src="../../assets/images/hospital.svg" />
        <a routerLink="/hospitals">Hospitals</a>
      </li>

      <!-- <li  >
                <img src="../../assets/images/claimIcon.svg" />
                <a >Patient</a>
            </li> -->
      <li [class.active]="currentRoute == '/setup-doctors'">
        <img src="../../assets/images/setupDoctorIcon.svg" />
        <a routerLink="/setup-doctors">Doctors</a>
      </li>
      <li [class.active]="currentRoute == '/payer-details'">
        <img src="../../assets/images/lookupIcon.svg" />
        <a routerLink="/payer-details">Payer Details</a>
      </li>
      <!--
            <li [class.active]="currentRoute == '/insurance-lookup'">
                <img src="../../assets/images/lookupIcon.svg" />
                <a routerLink="/insurance-lookup">Insurance Lookup</a>
            </li> -->
      <!-- <li>
                <img src="../../assets/images/settingsIcon.svg" />
                <a>Settings</a>
            </li> -->
    </ul>
  </div>
</nav>

<div
  class="modal fade"
  id="staticBackdrop"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="staticBackdropLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel"></h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <p class="logout_text">Are you sure you want to logout?</p>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          data-bs-dismiss="modal"
        >
          No
        </button>
        <button type="button" class="btn btn-primary" (click)="logoutClick()">
          Yes
        </button>
      </div>
    </div>
  </div>
</div>
